export default __webpack_public_path__ + "8b527b0b3b153a4dfc90f94ab1ac589b.png";